const SDK_VERSION = '7.38.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
